import {create} from 'zustand'
import socket from '../socketio/socketio.js'

let logsRequest = 0

const useAdminStore = create((set) => ({
    logs: [],
    totalLogs: 0,
    logsLoading: false,
    logsError: '',
    getLogs: (pageSize, page, search) => {
        // Only the answer to the newest request is shown, an earlier one that arrives later is ignored
        const request = ++logsRequest

        set({logsLoading: true, logsError: ''})

        socket.emit('admin.getLogs', sessionStorage.token, pageSize, page, search, (err, logs, totalLogs) => {
            if (request !== logsRequest) {
                return
            }

            if (err) {
                set({logs: [], totalLogs: 0, logsLoading: false, logsError: err})
            } else {
                set({logs: logs || [], totalLogs: totalLogs || 0, logsLoading: false})
            }
        })
    },
    resellers: [],
    /*
    Very basic, does not have all functionality as the original yet
    TODO: Add functionality from the original
    */
    getResellers: (includeArchived = false) => {
        socket.emit('admin.getResellers', sessionStorage.token, includeArchived, (err, resellers) => {
            set({resellers})
        })
    },
    // Id, name and reseller of all customers
    customerNames: [],
    getCustomerNames: () => {
        socket.emit('admin.getCustomerNames', sessionStorage.token, (err, customerNames) => {
            !err && set({customerNames})
        })
    },
    searchOrderAndParcel: (trackTraceOrId, callback) => {
        socket.emit('admin.searchOrderAndParcel', sessionStorage.token, trackTraceOrId, callback)
    }
}))

export default useAdminStore
